import { globalUrl } from '../config'

export function getOrgUrlInstance($http) {
  let orgUrl = ''

  return {
    getOrgUrl() {
      return new Promise((resolve, reject) => {
        $http.get(globalUrl.get_authorization_url).then(res => {
          const urlObj = new URL(res.data.auth_url)
          const params = {
            client_id: urlObj.searchParams.get('client_id'),
            redirect_uri: encodeURIComponent(urlObj.searchParams.get('redirect_uri')),
            state: urlObj.searchParams.get('state'),
            response_type: 'code',
          }
          this.orgUrl = `https://sso.cxstar.cn/oauth/authorize?client_id=${params.client_id}&redirect_uri=${params.redirect_uri}&state=${params.state}&response_type=${params.response_type}`
          resolve(this.orgUrl)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getOrgUrlSync() {
      return this.orgUrl
    },
    setOrgUrl(url) {
      this.orgUrl = url
    }
  }
}
